(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bit-complete-solution"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bit-kit-builder')) {
    customElements.define(
      'bit-kit-builder',
      class BitKitBuilder extends HTMLElement {
        connectedCallback() {
          this.observer = new MutationObserver(() => this.initialize());
          this.observer.observe(this, { childList: true, subtree: true });
          this.initialize();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        initialize() {
          if (this.initialized || !this.querySelector('[data-bit-kit-check]')) return;
          this.initialized = true;
          this.mainVariants = JSON.parse(this.querySelector('[data-bit-main-variants]').textContent);
          this.addEventListener('change', () => this.updateTotal());
          this.querySelector('[data-bit-kit-submit]').addEventListener('click', () => this.addKit());
          document.addEventListener('change', (event) => {
            if (event.target.closest('product-info')) {
              window.setTimeout(() => this.updateTotal(), 0);
            }
          });
          this.updateTotal();
        }

        getMainForm() {
          return (
            document.querySelector('product-info form[action*="/cart/add"]') ||
            document.querySelector('form[action*="/cart/add"]')
          );
        }

        getMainVariant() {
          const form = this.getMainForm();
          const id = form?.querySelector('[name="id"]')?.value;
          return this.mainVariants.find((variant) => String(variant.id) === String(id)) || this.mainVariants[0];
        }

        getSelectedAccessories() {
          return Array.from(this.querySelectorAll('[data-bit-kit-item]'))
            .filter((item) => item.querySelector('[data-bit-kit-check]').checked)
            .map((item) => {
              const variant = item.querySelector('[data-bit-kit-variant]');
              const option = variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
              return {
                id: Number(variant.value),
                price: Number(option.dataset.price),
                quantity: 1,
              };
            });
        }

        updateTotal() {
          const mainVariant = this.getMainVariant();
          const accessories = this.getSelectedAccessories();
          const total = accessories.reduce((sum, item) => sum + item.price, Number(mainVariant?.price || 0));
          const formatter = new Intl.NumberFormat(this.dataset.locale || 'pt-BR', {
            style: 'currency',
            currency: this.dataset.currency || 'BRL',
          });
          this.querySelector('[data-bit-kit-total]').textContent = formatter.format(total / 100);
        }

        async addKit() {
          const button = this.querySelector('[data-bit-kit-submit]');
          const status = this.querySelector('[data-bit-kit-status]');
          const form = this.getMainForm();
          const mainVariant = this.getMainVariant();
          const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
          const items = [{ id: Number(mainVariant.id), quantity }, ...this.getSelectedAccessories()];

          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          status.textContent = '';

          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ items }),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message);
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            status.textContent = error.message || 'Não foi possível adicionar o kit. Tente novamente.';
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
